import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    signatureLink: String,
    redirectUrl: String,
    containerId: String,
    isSandbox: Boolean,
  };

  connect() {
    this.initWidget();
  }

  initWidget() {
    const yousign = new Yousign({
      signatureLink: this.signatureLinkValue,
      iframeContainerId: this.containerIdValue,
      isSandbox: this.isSandboxValue,
    });

    yousign.onSuccess(() => {
      window.location.replace(this.redirectUrlValue);
    });
  }
}
